export default "https://cdn-static.gokick.com/assets/abc7ffeff8198bd9a29b582a19941a8ba3b1c5b9/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";